import { useState, useEffect } from 'react';

const useScreenWidth = (width) => {
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > (width || 1380));

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > (width || 1380));
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isWideScreen;
};

export default useScreenWidth;
